import { css, LitElement } from 'lit-element';
import { createGlobalStyles } from '../utils';

export class UcImage extends LitElement {
  constructor() {
    super();

    createGlobalStyles('uc-image-stylesheet', styles);
  }

  createRenderRoot() {
    return this;
  }
}

const styles = css`
  uc-image {
    display: block;

    line-height: 0;
  }

  uc-image picture {
    display: block;
    width: var(--img-width, 100%);
    height: var(--img-height, auto);
  }

  uc-image img {
    width: var(--img-width, 100%);
    height: var(--img-height, auto);
    object-fit: var(--img-object-fit, initial);

    -webkit-user-drag: none;
  }
`;
